"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CloseCircleFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg"));
var _HelpCircleLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/HelpCircleLine.svg"));
var _ahooks = require("ahooks");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _utils = require("../_util/utils");
var _icon = _interopRequireDefault(require("../icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HelpInfo = props => {
  const {
    title,
    content,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-helpInfo");
  const space = 24;
  const triggerEleRef = React.useRef(null);
  const drawerEleRef = React.useRef(null);
  const [top, setTop] = React.useState(space);
  const [open, setOpen] = React.useState(false);
  const openDrawer = () => {
    const containerElement = document.getElementById('popupContainer');
    setTop(containerElement ? containerElement.getBoundingClientRect().top : space);
    setOpen(true);
  };
  const closeDrawer = () => {
    setOpen(false);
  };

  // 点击空白处关闭
  (0, _ahooks.useClickAway)(closeDrawer, [triggerEleRef, drawerEleRef]);
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...attrs.data,
    className: (0, _classnames.default)(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      ref: triggerEleRef,
      className: "".concat(baseClassName, "-trigger"),
      onClick: () => {
        open ? closeDrawer() : openDrawer();
      },
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "suggest/HelpCircleLine"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Drawer, {
      open: open,
      mask: false,
      width: 400 + space,
      placement: "right",
      rootClassName: "".concat(baseClassName, "-drawer"),
      styles: {
        wrapper: {
          paddingTop: top,
          paddingRight: space,
          paddingBottom: space
        }
      },
      onClose: closeDrawer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "".concat(baseClassName, "-drawer-inner"),
        ref: drawerEleRef,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "".concat(baseClassName, "-drawer-title"),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            className: "drawer-close-btn",
            onClick: closeDrawer,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
              type: "suggest/CloseCircleFill"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "".concat(baseClassName, "-drawer-content"),
          children: content
        })]
      })
    })]
  });
};
var _default = exports.default = HelpInfo;